import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4347895d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("small", _hoisted_1, "Copyright © 2022 ASKing Co., Ltd. All Rights Reserved."))
}